import {
  CapabilitiesMarketplaceResponseDataSchema,
  CapabilitiesResponseDataSchema,
  CapabilityIdentifier,
  CapabilityResponseDataSchema,
} from "schema"
import z from "zod"
import { CapabilityInstructionDialog } from "./CapabilityInstructionDialog"
import { CapabilityIntegrationDialog } from "./CapabilityIntegrationDialog"
import { CapabilityMCPDialog } from "./CapabilityMCPDialog"
import { CapabilityWebhookDialog } from "./CapabilityWebhookDialog"

type Props<Mode extends "install" | "configure"> = {
  capability: Mode extends "install"
    ? z.infer<typeof CapabilitiesMarketplaceResponseDataSchema>[number]
    : z.infer<typeof CapabilitiesResponseDataSchema>[number]
  mode: Mode
  onOpenChange: (open: boolean) => void
  onConfigure?: (capability: z.infer<typeof CapabilityResponseDataSchema>) => void
}

export function CapabilityDialog<Mode extends "install" | "configure">({
  capability,
  mode,
  onOpenChange,
  onConfigure,
}: Props<Mode>) {
  const isWebhook = capability.identifier === CapabilityIdentifier.Webhook
  const isInstruction = capability.identifier === CapabilityIdentifier.Instruction
  const isMCP = capability.identifier === CapabilityIdentifier.MCP

  if (isWebhook) {
    return (
      <CapabilityWebhookDialog
        capability={capability}
        mode={mode}
        onOpenChange={onOpenChange}
        onConfigure={onConfigure}
      />
    )
  }

  if (isInstruction) {
    return (
      <CapabilityInstructionDialog
        capability={capability}
        mode={mode}
        onOpenChange={onOpenChange}
        onConfigure={onConfigure}
      />
    )
  }

  if (isMCP) {
    return (
      <CapabilityMCPDialog
        capability={capability}
        mode={mode}
        onOpenChange={onOpenChange}
        onConfigure={onConfigure}
      />
    )
  }

  return (
    <CapabilityIntegrationDialog
      capability={capability}
      mode={mode}
      onOpenChange={onOpenChange}
      onConfigure={onConfigure}
    />
  )
}
